<script>
    import Placeholder from "../components/placeholder/Placeholder.svelte";
      export let load;
      let items = [];
      let itemsDisplay = false;
      let loading = "block";
      $: fetch('https://penapublik.com/wp-json/wp/v2/posts?per_page='+load)
          .then(r => r.json())
          .then(data => {
              items = data;
              itemsDisplay = true;
              loading = "hidden";
          });
         let uid= Math.random().toString(36).substring(2);
  
  </script>
  
  
  <div class="{loading}  flex items-center flex-wrap mx-auto my-5 lg:my-0 ">
  
      <div class="mx-auto lg:w-1/3 w-full lg:px-2 px-2 py-2">
          <div class="group block px-4 py-3 bg-white shadow-md rounded-md cursor-pointer hover:text-green-700">
              <Placeholder type="5" css=""></Placeholder>
          </div>
      </div>
  
      <div class="mx-auto lg:w-1/3 w-full lg:px-2 px-2 py-2">
          <div class="group block px-4 py-3 bg-white shadow-md rounded-md cursor-pointer hover:text-green-700">
              <Placeholder type="5" css=""></Placeholder>
          </div>
      </div>
      <div class="mx-auto lg:w-1/3 w-full lg:px-2 px-2 py-2">
          <div class="group block px-4 py-3 bg-white shadow-md rounded-md cursor-pointer hover:text-green-700">
              <Placeholder type="5" css=""></Placeholder>
          </div>
      </div>
   
  </div>
  
  {#if itemsDisplay}
  <div class=" flex items-center flex-wrap mx-auto my-5 lg:my-0 ">
      
  {#each items as p, i}  
  <div class="mx-auto lg:w-1/3 w-full lg:px-2 px-2 py-2">
  <a class="group block px-4 py-3 bg-white shadow-md rounded-md cursor-pointer hover:text-green-700" href="{p.link}">
      <div class="flex justify-between items-center"> 
          <span class="text-sm font-light text-gray-800">Berita</span>
          <span class="bg-indigo-200 text-indigo-800 px-3 py-0 rounded-full text-xs">PenaPublik.com</span>
      </div>
      <div>
      <h3 class="lg:text-base md:text-sm text-sm font-semibold mt-2 group-hover:text-green-700">{@html p.title.rendered}</h3> 
      </div>
      <div> 
      </div>
  </a> 
  </div>  
      {/each}
  
  </div> 
   
  {/if}